import service from "@/utils/request";

export function getPageByPoolNumApi(data) {
    return service({
        url: "/packageSystemConfig/getPageByPoolNum",
        method: "get",
        params: data,
    });
}

export function getPoolInfoApi(data) {
    return service({
        url: "/packageSystemConfig/getPoolInfo",
        method: "get",
        params: data,
    });
}
export function getPoolStatApi(data) {
    return service({
        url: "/packageSystemConfig/getPoolStat",
        method: "get",
        params: data,
    });
}

export function editPoolMaxTokenApi(data) {
    return service({
        url: "/packageSystemConfig/editPoolMaxToken",
        method: "get",
        params: data,
    });
}

export function getPoolPeopleCountApi(data) {
    return service({
        url: "/packageSystemConfig/getPoolPeopleCount",
        method: "post",
        data,
    });
}

export function getAmountStatApi(data) {
    return service({
        url: "/packageSystemConfig/getAmountStat",
        method: "post",
        data,
    });
}

export function setComprehensiveAmountApi(data) {
    return service({
        url: "/packageSystemConfig/setComprehensiveAmount",
        method: "post",
        data,
    });
}
